module.exports = __webpack_public_path__ + "static/media/budget.44e35210.png";